// Rendered when the RTA_SYSTEMS_V1 flag is off (or the signed-in user is not
// the founder). Since the dashboard is a founder-only tool, a non-founder
// landing here should simply see a "not for you" message, not the sign-in
// card — the sign-in card is for founders who haven't auth'd yet.
export function OldShellPlaceholder() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="glass mx-auto max-w-md p-8 text-center">
        <div className="text-xs uppercase tracking-[0.18em] text-ink-400">rta.systems</div>
        <h1 className="mt-2 text-2xl font-semibold">Founder console</h1>
        <p className="mt-2 text-sm text-ink-600">
          This console is restricted. Access is gated by the{' '}
          <code className="rounded bg-white/70 px-1">RTA_SYSTEMS_V1</code> feature flag and
          limited to the founder account. If you believe you should have access, contact{' '}
          <code className="rounded bg-white/70 px-1">rushang.bhardwaj@rta.systems</code>.
        </p>
      </div>
    </div>
  );
}
